<template>
  <div class="filter-form">
    <sh-button-deprecated @click="resetFilters" ghost size="xsmall" class="reset-button">
      {{ $t('CONTENT_FILTER_RESET_DEFAULTS_CTA') }}
    </sh-button-deprecated>
    <filter-tag-group class="filter-tags" :tags="Object.values(tags)" @click="changeFilterType" />

    <form @submit.prevent="onSubmit">

      <locations-fieldset
        v-if="this.houses.length + this.citiesWithoutHouses.length > 0
          && currentFilterType === FILTER_TYPES.LOCATION"
        v-model="filters.venueId"
        :houses="houses"
        :citiesWithoutHouses="citiesWithoutHouses"
        :favoriteVenues="favoriteVenues"
        :localHouse="localHouse"
      />

      <categories-fieldset
        v-else-if="categories.length > 0 && currentFilterType === FILTER_TYPES.CATEGORY"
        v-model="filters.categories"
        :categories="categories"
      />

      <generic-error v-else />

      <sh-button
        color="primary"
        fullWidth
        size="medium"
        type="submit"
      >
        {{ $t('EXPLORE_EVENTS_FILTER_APPLY_CTA') }}
      </sh-button>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import FilterTagGroup from '~/components/filter-tag-group'
import LocationsFieldset from '~/components/fieldsets/locations'
import CategoriesFieldset from '~/components/fieldsets/categories'

const { mapGetters: mapNoteGetters } = createNamespacedHelpers('content/notes')
const { mapGetters: mapAccountGetters } = createNamespacedHelpers('user/account')
const { mapGetters: mapVenueGetters } = createNamespacedHelpers('venues')
const { mapGetters: mapCategoryGetters } = createNamespacedHelpers('content/categories')

const FILTER_TYPES = {
  LOCATION: 'LOCATION',
  CATEGORY: 'CATEGORY'
}

export default {
  components: {
    FilterTagGroup,
    LocationsFieldset,
    CategoriesFieldset
  },

  data () {
    return {
      FILTER_TYPES,
      currentFilterType: FILTER_TYPES.CATEGORY,
      filters: {
        categories: [],
        venueId: []
      }
    }
  },

  mounted () {
    const { categories, venueId } = this.noteFilters
    this.filters.categories = categories
    this.filters.venueId = venueId
  },

  computed: {
    ...mapAccountGetters(['localHouse', 'favoriteVenues']),
    ...mapVenueGetters(['houses', 'citiesWithoutHouses']),
    ...mapNoteGetters(['noteFilters']),
    ...mapCategoryGetters({ noteCategories: 'resources' }),

    categories () {
      return this.noteCategories.sort(
        (a, b) => a.categoryName.localeCompare(b.categoryName)) || []
    },

    tags () {
      return {
        [FILTER_TYPES.LOCATION]: {
          name: this.$t('EXPLORE_EVENTS_FILTER_LOCATION_LABEL'),
          count: this.currentFilterType === FILTER_TYPES.LOCATION,
          type: FILTER_TYPES.LOCATION
        },
        [FILTER_TYPES.CATEGORY]: {
          name: this.$t('EXPLORE_EVENTS_FILTER_CATEGORIES_LABEL'),
          count: this.currentFilterType === FILTER_TYPES.CATEGORY,
          type: FILTER_TYPES.CATEGORY
        }
      }
    }
  },
  methods: {
    onSubmit () {
      const { filters } = this

      this.$emit('applyFilters', filters)
    },

    changeFilterType (type) {
      this.currentFilterType = type
    },

    resetFilters () {
      this.$emit('applyFilters', {})
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  button[type="submit"] {
    margin-bottom: auto;
  }
</style>
